module.exports = "/_next/static/images/edvin-9e79d2d0cfeae256c335deb0fac121d7.svg";